import { useAuth } from "@/hooks/useAuth";
import { Navigate, Outlet } from "react-router-dom";

export const ProtectedRoute = () => {
  const { token } = useAuth();

  return token !== null ? <Outlet /> : <Navigate to="/login" replace />;
};